"use client";
import { Box } from "@chakra-ui/react";
import WrapCards from "@/components/cardsWrap";
import { SERVICES_CONSTANTS } from "./constants";

const ServicesCards = () => {
  return (
    <Box id="services">
      <WrapCards
        title={SERVICES_CONSTANTS.title}
        list={SERVICES_CONSTANTS.list}
        Width={{
          base: "100%",
          sm: "40vw",
          md: "26vw",
          lg: "20vw",
          "2xl": "19vw",
        }}
        maxWidth={"360px"}
        spacing={{ base: 8, sm: "4vw", md: "3vw", lg: "2vw" }}
        hoverEffect={true}
      />
    </Box>
  );
};

export default ServicesCards;
